import { Serializer } from "../resource/serializer.interface";
import { PreferenceChannel } from "./preferente-channel.model";

export class PreferenceChannelSerializer implements Serializer {
    fromJson(json: any): PreferenceChannel {
        const channel = new PreferenceChannel();
        channel.id = json.id;
        channel.name = json.name;
        channel.code = json.code;
        channel.description = json.description;
        channel.status = json.status;
        channel.tenantId = json.tenant_id;
        channel.createdAt = json.createdAt;
        channel.updatedAt = json.updatedAt;
        return channel;
    }

    toJson(channel: PreferenceChannel): any {
        return {
            id: channel.id,
            name: channel.name,
            code: channel.code,
            description: channel.description,
            status: channel.status,
            tenant_id: channel.tenantId,
            createdAt: channel.createdAt,
            updatedAt: channel.updatedAt
        };
    }
}